<template>
  <div>
    <div class="text-center">
      <h2  class="font-weight-light">Add New Address</h2>
    </div>
    <v-container>
      <v-row>
        <v-col
         cols="12"
        >
          <v-form
            ref="form"
          >
            <v-alert
              v-if="hasErrors()"
              color="warning">
              <ul>
                <li v-for="(error, index) in errors" :key="index">{{ error }}</li>
              </ul>
            </v-alert>

            <v-checkbox
              v-model="Address.Default"
              label="Set Default"
            ></v-checkbox>
            <v-select
              v-model="Address.Country"
              :items="Countries"
              label="Country"
              return-object
              single-line
              readonly
            ></v-select>
            <v-text-field
              v-model="Address.Line1"
              label="Address Line 1 (or Company Name)"
              placeholder="Street address, P.O. box, company name, c/o"
              required
            ></v-text-field>
            <v-text-field
              v-model="Address.Line2"
              label="Address Line 2 (optional)"
              placeholder="Apartment, suite, unit, building, floor, etc."
              required
            ></v-text-field>
            <v-text-field
              v-model="Address.City"
              label="City"
              required
            ></v-text-field>
            <v-select
              v-model="Address.State"
              :items="States"
              label="State/Province/Region (if appropriate)"
            ></v-select>
            <v-text-field
              v-model="Address.PostalCode"
              label="Postal Code/ZIP"
              required
            ></v-text-field>
            <v-text-field
              v-model="Address.DeliveryNotes"
              label="Delivery Notes"
              placeholder="Do we need a security code or a call box number to access this address?"
              required
            ></v-text-field>
          </v-form>
          <v-row>
            <v-col>
              <v-btn
                to="/addresses"
                color="primary"
                dark
              >
                Back
              </v-btn>
            </v-col>
            <v-col align="right">
              <v-btn
                color="success"
                class="mr-4"
                @click="Save"
              >
                Save
              </v-btn>
            </v-col>
          </v-row>
        </v-col>
      </v-row>
    </v-container>
  </div> 
</template>

<script>
import {mapState} from "vuex";

export default {
  name: "AddressesAdd",
  data() {
    return {
      errors: [],
      Countries: ['Canada'],
      States: ['Alberta','British Columbia','Manitoba','New Brunswick','Newfoundland and Labrador','Northwest Territories','Nova Scotia','Nunavut','Ontario','Prince Edward Island','Quebec','Saskatchewan','Yukon'] ,
      Address: {
        Default: true,
        Country: 'Canada',
        Line1: '',
        Line2: '',
        State: 'Ontario',
        PostalCode: '',
        DeliveryNotes: ''
      }
    }
  },
  computed: mapState(["continueHref"]),
  methods: {
    Save() {
      this.errors = []
      this.$axios.post(this.$cfg.ACCOUNTS_API_URL + 'addresses', this.Address)
        .then((response) => {
          console.log(response.data)
        })
        .then(() =>{
          this.$store.dispatch("addNotification", {
            type: 'success',
            message: 'Address was sucessfully saved.'
          });

           if (this.continueHref) {
            window.location.href = this.continueHref
          } else {
            this.$router.push({ name: 'addresses' })
          }
        })
        .catch((error) => {
          if (error.response) {
            // The request was made and the server responded with a status code
            // that falls out of the range of 2xx
            // console.log(error.response.data.errors)
            this.errors = error.response.data.errors
          } else if (error.request) {
            // The request was made but no response was received
            // `error.request` is an instance of XMLHttpRequest in the browser and an instance of
            // http.ClientRequest in node.js
            this.errors = ["Network error"]
          } else {
            // Something happened in setting up the request that triggered an Error
            this.errors = ["We are really sorry our systems seems to be unhealty now. Please try again later or contact us."]
          }
        })
    },
    hasErrors() {
      return this.errors.length > 0
    },
  }
}
</script>
